import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Typography, Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseGeneralPages } from "../../UseGeneralPages";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../../../components/CustomPagination";
import { rsProgress, rsActiveMenu } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteRow from "../../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";

export default function PageFAQ(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { DeletePageFAQ, UpdatePageFAQ } = UseGeneralPages();
  const [searchSubGroup, setSearchSubGroup] = useState("");

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    generalID: undefined,
    id: undefined,
  });

  const [filt, setFilt] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    setFilt([
      {
        columnField: "title",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    return navigate("/generalpages/pageDetail/addPageFAQ", {
      state: {
        id: props.GeneralID,
        search: searchSubGroup,
        scrollTo: "PageFAQ",
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "question",
      headerName: " سوال ",
      headerAlign: "center",
      width: 700,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.question
              .replace(/(<([^>]+)>)/gi, "")
              .replace(/(&nbsp;)/gi, " ")}
          </Typography>
        );
      },
    },
    {
      field: "answer",
      headerName: "پاسخ",
      hide: true,
      width: 220,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.answer}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    id: cellValues.row.id,
                    generalID: props.GeneralID,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("/generalpages/pageDetail/editPageFAQ", {
                    state: {
                      model: cellValues.row,
                      images: props.image ? props.image : [],
                      id: props.GeneralID,
                      search: searchSubGroup,
                      scrollTo: "PageFAQ",
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchSubGroup}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                setSearchSubGroup(evt.target.value);
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "25rem" }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        rows={props.data ? props.data : []}
        columns={columns}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={props.data && props.data.length ? props.data.length : 1}
        enableRangeSelection={true}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: props.data && props.data.length ? props.data.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={""}
        callback={() => {
          setProgress(true);
          DeletePageFAQ(deleteState.id, () => {
            props.refresh(deleteState.generalID);
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
